import React from 'react'
import { Link } from 'react-router-dom'
import ContactForm from '../components/ContactForm'
import { ArrowRightIcon, CheckIcon, QrCodeIcon, DevicePhoneMobileIcon, ShareIcon, SparklesIcon } from '@heroicons/react/24/outline'
import DevFloatingTab from '../../dev/components/DevFloatingTab'

function HomePage() {
  const features = [
    {
      name: 'Diseños Profesionales',
      description: 'Plantillas modernas y elegantes adaptadas a tu estilo profesional.',
      icon: QrCodeIcon,
    },
    {
      name: 'Totalmente Personalizable',
      description: 'Cambia colores, fuentes, imágenes y contenido fácilmente.',
      icon: DevicePhoneMobileIcon,
    },
    {
      name: 'Compartir Fácil',
      description: 'Comparte tu Dkard por WhatsApp, QR, email o redes sociales.',
      icon: ShareIcon,
    },
  ]

  const templates = [
    {
      id: 1,
      name: 'Presentación Profesional',
      description: 'Perfecta para ejecutivos y freelancers',
      image: '/dkardCMS1.png',
    },
    {
      id: 2,
      name: 'Servicios Premium',
      description: 'Ideal para profesionales de servicios',
      image: '/dkardCMS3.png',
    },
    {
      id: 3,
      name: 'Landing Personal',
      description: 'One-page completa con tu información',
      image: '/dkardCMS4.png',
    },
    {
      id: 4,
      name: 'Catálogo de Productos',
      description: 'Perfecta para negocios con productos',
      image: '/portada.png',
    },
  ]

  return (
    <div className="bg-white">
      {/* Hero Section */}
      <div className="relative overflow-hidden bg-gradient-to-br from-primary-50 to-accent-50">
        <div className="container-custom">
          <div className="relative z-10 pb-8 bg-transparent sm:pb-16 md:pb-20 lg:pb-28 xl:pb-32">
            <main className="mt-10 mx-auto max-w-7xl px-4 sm:mt-12 sm:px-6 md:mt-16 lg:mt-20 lg:px-8 xl:mt-28">
              <div className="lg:grid lg:grid-cols-2 lg:gap-8">
                <div className="text-center lg:text-left">
                  <div className="inline-flex items-center px-3 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-semibold mb-4">
                    <SparklesIcon className="w-4 h-4 mr-1" /> NFC • QR • Plantillas
                  </div>
                  <h1 className="text-4xl md:text-5xl lg:text-6xl font-extrabold tracking-tight text-gray-900 leading-tight">
                    <span className="block">Crea tu</span>
                    <span className="block text-gradient">tarjeta digital</span>
                    <span className="block">profesional</span>
                  </h1>
                  <p className="mt-4 md:mt-6 text-base sm:text-lg md:text-xl text-gray-600 max-w-xl lg:max-w-2xl">
                    Diseña y comparte Dkards modernas y personalizables. Perfectas para networking profesional.
                  </p>
                  <div className="mt-6 md:mt-8 flex flex-col sm:flex-row sm:justify-center lg:justify-start gap-3">
                    <Link to="/auth/register" className="inline-flex items-center justify-center px-8 py-3 rounded-md text-white bg-primary-600 hover:bg-primary-700 md:py-4 md:text-lg">
                      Empezar
                      <ArrowRightIcon className="ml-2 h-5 w-5" />
                    </Link>
                    <Link to="/templates" className="inline-flex items-center justify-center px-8 py-3 rounded-md text-primary-600 bg-white hover:bg-gray-50 md:py-4 md:text-lg">
                      Plantillas DKard
                    </Link>
                  </div>
                  <div className="mt-6 flex items-center gap-6 text-sm text-gray-700 justify-center lg:justify-start">
                    <div className="flex items-center"><CheckIcon className="w-5 h-5 text-primary-600 mr-2" /> Personaliza colores y fuentes</div>
                    <div className="flex items-center"><CheckIcon className="w-5 h-5 text-primary-600 mr-2" /> Compartir por WhatsApp y QR</div>
                  </div>
                </div>
              </div>
            </main>
          </div>
        </div>
        
        <div className="lg:absolute lg:inset-y-0 lg:right-0 lg:w-1/2">
          <div className="relative h-56 sm:h-72 md:h-96 lg:h-full w-full">
            <img className="absolute inset-0 w-full h-full object-cover" src="/demodkard.png" alt="Dkard" />
            <div className="absolute inset-0" style={{ backgroundImage: 'linear-gradient(90deg, rgba(255,255,255,0.92) 0%, rgba(255,255,255,0.7) 35%, rgba(255,255,255,0) 70%)' }}></div>
          </div>
        </div>
      </div>

      <DevFloatingTab variant="vertical" />

      {/* Features Section */}
      <div className="py-12 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="lg:text-center">
            <h2 className="text-base text-primary-600 font-semibold tracking-wide uppercase">Características</h2>
            <p className="mt-2 text-3xl leading-8 font-extrabold tracking-tight text-gray-900 sm:text-4xl">
              Todo lo que necesitas para tu presencia digital
            </p>
            <p className="mt-4 max-w-2xl text-xl text-gray-500 lg:mx-auto">
              Herramientas profesionales para crear la mejor impresión digital.
            </p>
          </div>

          <div className="mt-10">
            <div className="grid grid-cols-1 gap-10 sm:grid-cols-2 lg:grid-cols-3">
              {features.map((feature) => (
                <div key={feature.name} className="relative">
                  <div className="absolute flex items-center justify-center h-12 w-12 rounded-md bg-primary-500 text-white">
                    <feature.icon className="h-6 w-6" aria-hidden="true" />
                  </div>
                  <p className="ml-16 text-lg leading-6 font-medium text-gray-900">{feature.name}</p>
                  <p className="mt-2 ml-16 text-base text-gray-500">{feature.description}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>

      {/* Templates Preview Section */}
      <div className="py-12 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center">
            <h2 className="text-3xl font-extrabold text-gray-900 sm:text-4xl">Plantillas DKard</h2>
            <p className="mt-4 text-xl text-gray-500">
              Elige entre nuestras plantillas diseñadas por profesionales
            </p>
          </div>

          <div className="mt-12 grid grid-cols-1 gap-8 sm:grid-cols-2 lg:grid-cols-4">
            {templates.map((template) => (
              <div key={template.id} className="bg-white rounded-lg shadow-md overflow-hidden hover:shadow-lg transition-shadow duration-200">
                  <div
                  className="h-60 w-full rounded-t-lg flex items-center justify-center text-white"
                  style={{ backgroundImage: `linear-gradient(135deg, ${['#6242BF','#05C0FB','#806FC1','#05C0FB'][template.id-1] || '#6242BF'}, #05C0FB)` }}
                >
                  <div className="text-center">
                    <div className="text-xs opacity-80">Plantilla</div>
                    <div className="text-sm font-semibold">{template.name}</div>
                  </div>
                </div>
                <div className="p-6">
                  <h3 className="text-lg font-medium text-gray-900">{template.name}</h3>
                  <p className="mt-2 text-sm text-gray-500">{template.description}</p>
                  <div className="mt-4">
                    <Link to={`/templates?template=${template.id}`} className="text-primary-600 hover:text-primary-700 text-sm font-medium">Ver más →</Link>
                  </div>
                </div>
              </div>
            ))}
          </div>

          <div className="mt-12 text-center">
            <Link
              to="/templates"
              className="btn-primary"
            >
              Ver todas las plantillas
            </Link>
          </div>
        </div>
      </div>

      {/* Services We Offer */}
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-extrabold text-gray-900 sm:text-4xl">Servicios que ofrecemos</h2>
            <p className="mt-3 text-gray-600">Todo lo que necesitas para una Dkard profesional y efectiva</p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
            <div className="rounded-2xl border border-gray-200 shadow-sm p-6 bg-gradient-to-br from-primary-50 to-white">
              <div className="w-12 h-12 rounded-md bg-primary-100 text-primary-600 flex items-center justify-center mb-4">📱</div>
              <h3 className="text-lg font-semibold text-gray-900">Dkard Personalizada</h3>
              <p className="mt-2 text-sm text-gray-600">Diseño a medida con plantillas optimizadas y tu identidad visual.</p>
            </div>
            <div className="rounded-2xl border border-gray-200 shadow-sm p-6 bg-gradient-to-br from-accent-50 to-white">
              <div className="w-12 h-12 rounded-md bg-accent-100 text-accent-600 flex items-center justify-center mb-4">🔗</div>
              <h3 className="text-lg font-semibold text-gray-900">Integraciones y QR</h3>
              <p className="mt-2 text-sm text-gray-600">Botones de contacto, redes, WhatsApp, y código QR personalizado.</p>
            </div>
            <div className="rounded-2xl border border-gray-200 shadow-sm p-6 bg-gradient-to-br from-primary-50 to-white">
              <div className="w-12 h-12 rounded-md bg-primary-100 text-primary-600 flex items-center justify-center mb-4">🛒</div>
              <h3 className="text-lg font-semibold text-gray-900">Catálogo y Servicios</h3>
              <p className="mt-2 text-sm text-gray-600">Presenta productos o servicios con galerías y secciones claras.</p>
            </div>
            <div className="rounded-2xl border border-gray-200 shadow-sm p-6 bg-gradient-to-br from-accent-50 to-white">
              <div className="w-12 h-12 rounded-md bg-accent-100 text-accent-600 flex items-center justify-center mb-4">📈</div>
              <h3 className="text-lg font-semibold text-gray-900">Analítica básica</h3>
              <p className="mt-2 text-sm text-gray-600">Vistas, compartidos y escaneos para medir el impacto.</p>
            </div>
          </div>

          <div className="mt-12 text-center">
            <a href="/templates" className="btn-primary">Explorar plantillas</a>
          </div>
        </div>
      </section>

      {/* NFC Products Section */}
      <div className="py-12 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center">
            <h2 className="text-3xl font-extrabold text-gray-900 sm:text-4xl">Tarjetas y accesorios NFC</h2>
            <p className="mt-4 text-xl text-gray-500">Personalizados y enlazados a tu Dkard</p>
          </div>

          <div className="mt-12 text-center">
            <Link to="/nfc" className="btn-primary">Ver modelos NFC</Link>
          </div>
        </div>
      </div>

      {/* Contact Us */}
      <section className="py-16 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-extrabold text-gray-900 sm:text-4xl">Contáctanos</h2>
            <p className="mt-3 text-gray-600">¿Tienes preguntas? Escríbenos y veremos tu mensaje en el panel admin.</p>
          </div>
          <ContactForm />
        </div>
      </section>

      {/* CTA Section */}
      <div className="bg-primary-600">
        <div className="max-w-2xl mx-auto text-center py-16 px-4 sm:py-20 sm:px-6 lg:px-8">
          <h2 className="text-3xl font-extrabold text-white sm:text-4xl">
            <span className="block">¿Listo para crear tu Dkard?</span>
          </h2>
          <p className="mt-4 text-lg leading-6 text-primary-200">
            Comienza gratis y actualiza cuando necesites más funcionalidades.
          </p>
          <div className="mt-8 flex justify-center">
            <div className="inline-flex rounded-md shadow">
              <Link
                to="/auth/register"
                className="inline-flex items-center justify-center px-5 py-3 border border-transparent text-base font-medium rounded-md text-primary-600 bg-white hover:bg-primary-50"
              >
                Comenzar ahora
                <ArrowRightIcon className="ml-3 h-5 w-5" />
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default HomePage
